// Module
var code = "<div class=\"c-image-enlarge__overlay\"> <img src=\"<%= data.original %>\"/> </div> ";
// Exports
module.exports = code;